import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
// types
import type { StrapiSiteHeader, StrapiSingleResponse } from '@ts-strapi/interfaces'
// hooks
import { useStrapiFetch } from '@api/strapi/use-strapi-fetch.hook'

interface StrapiSiteHeaderHookReturn {
  refSiteHeader: ComputedRef<StrapiSiteHeader | null>
  refPending: Ref<boolean>
  refError: Ref<Error | null>
  refresh: () => Promise<void>
}

export const useStrapiSiteHeader = async (): Promise<StrapiSiteHeaderHookReturn> => {
  const strapiFetch = useStrapiFetch()

  const { data, pending, error, refresh } = await useAsyncData(
    'strapi:site-header',
    () => strapiFetch<StrapiSingleResponse<StrapiSiteHeader>>('/site-header', {
      params: {
        'populate[navItems][populate][groups][populate][columns][populate][links]': 'true',
        'populate[login]': 'true',
        'populate[cta]': 'true',
        'populate[banner][populate][image]': 'true',
      },
    }),
  )

  return {
    refSiteHeader: computed(() => data.value?.data ?? null),
    refPending: pending,
    refError: error as Ref<Error | null>,
    refresh: () => refresh(),
  }
}
